import * as React from "react";
const Loader = require("react-loader-spinner").default;
import { toast } from "react-toastify";
import * as Modal from "react-modal";
import hash from "../../assets/hash.png"

export default class Clients extends React.Component<any, any> {
  subscriptions:any;
  constructor(props: any) {
    super(props);
    this.state = {
      clients: [],
      loading: false,
      modalOn: false,
      newClient: {
        id: null,
        name: "",
      },
    };
  }

  loadClients = () => {
    fetch("clients/getAll", {
      method: "POST",
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ clients: data.clients });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };

  removeClient = (id: number, index: number) => {
    const confirmed = confirm("אתה בטוח?");
    if (!confirmed) return;
    this.setState({ loading: true });
    fetch("clients/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let clients = this.state.clients;
        clients.splice(index, 1);
        this.setState({
          loading: false,
          clients,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  handleChange = (e:any) => {
    const newClient = this.state.newClient
    newClient[e.target.name] = e.target.value;
    this.setState({newClient})
  }

  newClient = () => {
    const newClient = this.state.newClient;
    this.setState({ loading: true });
    fetch("clients/edit", {
      method: "POST",
      body: JSON.stringify(newClient),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let clients = this.state.clients;
        clients.unshift(data.client);
        this.setState({
          loading: false,
          clients,
          modalOn: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  componentDidMount() {
    this.loadClients();
      new window.Chart(this.subscriptions.getContext('2d'), {
        type: 'line',
        data: {
            labels: [],
            datasets: [{
                label: 'מנויים חודשיים',
                data: [],
                backgroundColor: "#2d3444",
                borderColor: "#2d3444"
            },
            {
              label: 'מנויים שנתיים',
              data: [],
              backgroundColor: "#2f98e0",
              borderColor: "#2f98e0"
          }]
        },
        options: {
          responsive: false,
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }
    });
  }

  public render() {
    const { clients } = this.state;
    return (
      <div id="users-root">
        <Modal isOpen={this.state.modalOn} className="newCategory-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                modalOn: false,
                newClient: { id: null, name: "" },
              });
            }}
          ></a>
          <input
            name="name"
            type="text"
            value={this.state.newClient.name || ""}
            placeholder={"שם לקוח"}
            onChange={(e) => {this.handleChange(e)}}
          />
          <input
            name="email"
            type="text"
            value={this.state.newClient.email || ""}
            placeholder={"אימייל"}
            onChange={(e) => {this.handleChange(e)}}
          />
           <input
            name="password"
            type="text"
            value={this.state.newClient.password || ""}
            placeholder={"סיסמה"}
            onChange={(e) => {this.handleChange(e)}}
          />
          <button
            className="submit"
            onClick={() => {
              this.newClient();
            }}
          >
            שמירה
          </button>
        </Modal>
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <div className="buttonsHeader">
        <i className="fa fa-bars" onClick={() => {this.props.openMenu()}}></i>
        <h1><img src={hash}></img>לקוחות</h1>

          <button
            onClick={() => {
              this.setState({
                modalOn: true,
                newClient: { id: null, name: "" },
              });
            }}
          >
            לקוח חדש
          </button>
        </div>

        <div className="board">
          <div className="graphs-view">
            <canvas className="big" ref={(el) => {this.subscriptions = el}}></canvas>
          </div>
          {clients.map((client: any, i: number) => {
            return (
              <div className="category" key={i}>
                <i
                  onClick={() => {
                    this.removeClient(client.id, i);
                  }}
                  className="fas fa-trash"
                ></i>
                    <div className="logo" style={{backgroundImage: `url()`}}></div>
                <span>
                  <a href={`/clients/${client.id}`}>{client.name}</a>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/clients/Clients.tsx